import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';

const MobileHeader = ({ onMenuPress }) => {
  return (
    <View style={styles.container}>
      {/* Hamburger Menu Button */}
      <TouchableOpacity 
        style={styles.menuButton} 
        onPress={onMenuPress}
        activeOpacity={0.7}
      >
        <View style={styles.hamburgerContainer}>
          <View style={styles.hamburgerLine} />
          <View style={styles.hamburgerLine} />
          <View style={styles.hamburgerLine} />
        </View>
      </TouchableOpacity>

      {/* Logo */}
      <View style={styles.logoContainer}>
        <img 
          src="/zecher-logo.png" 
          alt="Zecher"
          style={styles.logoImage}
          onError={(e) => {
            // Fallback to text logo if image fails to load
            e.target.style.display = 'none';
            e.target.nextSibling.style.display = 'flex';
          }}
        />
        <View style={[styles.logoFallback, { display: 'none' }]}>
          <View style={styles.logoIcon}>
            <Text style={styles.logoText}>Z</Text>
          </View>
          <Text style={styles.logoTitle}>echer</Text>
        </View>
      </View>

      {/* Spacer for potential right-side elements */}
      <View style={styles.rightSpacer} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 12,
    backgroundColor: '#FFFFFF',
    borderBottomWidth: 1,
    borderBottomColor: '#F3F4F6',
    height: 60,
    zIndex: 50,
    position: 'relative',
    width: '100%',
  },
  menuButton: {
    width: 48,
    height: 48,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 8,
    // Ensure it's tappable
    backgroundColor: 'transparent',
    zIndex: 60,
  },
  hamburgerContainer: {
    width: 24,
    height: 18,
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  hamburgerLine: {
    width: 24,
    height: 3,
    backgroundColor: '#374151',
    borderRadius: 2,
  },
  logoContainer: {
    flex: 1,
    alignItems: 'center',
    marginLeft: -48, // Center logo accounting for hamburger button
  },
  logoImage: {
    height: 32,
    width: 'auto',
    maxWidth: 120,
    objectFit: 'contain',
  },
  logoFallback: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  logoIcon: {
    width: 32,
    height: 32,
    backgroundColor: '#2563EB',
    borderRadius: 6,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 8,
  },
  logoText: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#FFFFFF',
  },
  logoTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#111827',
  },
  rightSpacer: {
    width: 48, // Balance the hamburger button
  },
});

export default MobileHeader; 